import { PRODUCTION_HOST, STAGING_HOST } from '../config'

export const isProduction = (): boolean => location.host === PRODUCTION_HOST
export const isProductionOrStaging = (): boolean => {
	return location.host === STAGING_HOST || location.host === PRODUCTION_HOST
}
export const getEnvironment = (): 'prod' | 'stage' | 'local' => {
	if ( isProduction() ) {
		return 'prod'
	} else if ( location.host === STAGING_HOST ) {
		return 'stage'
	} else {
		return 'local'
	}
}
